// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCU4heIsRI3-xOwSGXJH9ZMnPb_nPpC8bw",
  authDomain: "khoja-distributions.firebaseapp.com",
  projectId: "khoja-distributions",
  storageBucket: "khoja-distributions.firebasestorage.app",
  messagingSenderId: "877145244190",
  appId: "1:877145244190:web:77e9a8cb994a01892de40f",
  measurementId: "G-HYL8X5Q3T9"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-south1');

export { auth, db, storage, functions };